/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Dashboard_Storage_Limit_ReachedInputs */



/**
* | output |
* | --- |
* | "Storage limit reached ({used} of {limit}). Uploads are blocked until you free up space or upgrade." |
*
* @param {Dashboard_Storage_Limit_ReachedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_storage_limit_reached = /** @type {((inputs: Dashboard_Storage_Limit_ReachedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Storage_Limit_ReachedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicherlimit erreicht (${i?.used} von ${i?.limit}). Uploads sind blockiert, bis Sie Speicherplatz freigeben oder upgraden.`)
	return /** @type {LocalizedString} */ (`Storage limit reached (${i?.used} of ${i?.limit}). Uploads are blocked until you free up space or upgrade.`)
});